module.exports = __webpack_public_path__ + "static/media/GettyGuide.5b91f233.png";